import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface StandardTextStringModel {
  [key: string]: string | number | boolean | undefined;
  stringId?: number;
  searchOrder?: number;
  isNew?: boolean;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portuguese?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetStandardTextStringsRequest {}

class GetStandardTextStringsResponse {
  standardTextStrings?: StandardTextStringModel[];
}

class CreateStandardTextStringRequest {
  standardTextStringModel?: StandardTextStringModel;
}

class CreateStandardTextStringResponse {
  stringId?: number;
}

class UpdateStandardTextStringRequest {
  stringId?: number;
  standardTextStringModel?: StandardTextStringModel;
}

class DeleteStandardTextStringRequest {
  stringId?: number;
}

class AddNewStandardTextsRequest {
  constructor(public newStandardTexts: string[]) {}
}

export const glossaryStandardTextStringApi = {
  async getStandardTextStrings(): Promise<Result<StandardTextStringModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetStandardTextStringsResponse>(
        "GetStandardTextStrings",
        {} as GetStandardTextStringsRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.standardTextStrings ?? [] };
    }

    return response;
  },

  async createStandardTextString(
    standardTextStringModel: StandardTextStringModel,
  ): Promise<Result<number | undefined>> {
    let response =
      await backendApi.sendAndGetResponseAsync<CreateStandardTextStringResponse>(
        "CreateStandardTextString",
        {
          standardTextStringModel: standardTextStringModel,
        } as CreateStandardTextStringRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.stringId ?? undefined };
    }

    TrimValidationFields(response.problem, "StandardTextStringModel");

    return response;
  },

  async updateStandardTextString(
    stringId?: number,
    standardTextStringModel?: StandardTextStringModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateStandardTextString", {
      stringId: stringId,
      standardTextStringModel: standardTextStringModel,
    } as UpdateStandardTextStringRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "StandardTextStringModel");

    return response;
  },

  async deleteStandardTextString(stringId?: number): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteStandardTextString", {
      stringId: stringId,
    } as DeleteStandardTextStringRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },

  async addNewStandardTexts(newStandardTexts: string[]): Promise<Result<any>> {
    return await backendApi.sendAsync(
      "AddNewStandardTexts",
      new AddNewStandardTextsRequest(newStandardTexts),
    );
  },
};
